/**
 * 索赔2.0  审核处理
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/23      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import {Button, Spin, Radio, Input, InputNumber, message,} from "antd";
import {symbolMoneyUtil,toFixed2,isEmpty,isEmptyObject} from '@utils/utils';
import Locale from "@utils/locale";
import IntegerCtrlInput from "@components/Input/IntegerCtrlInput";// 数字组件
import Lang from "@components/Lang/Lang";
import AfterSaleService from "../../AfterSale.action";
const { TextArea } = Input;
const locale = Locale.current();

export default class DetailHandleForm extends React.Component{
    static propTypes = {
        sku:PropTypes.object,
    }
    static defaultProps = {
        sku:{}, //sku 数据源
        claimDemageOrderId:"",
        values:{}
    }
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
        //获取头部数据
        this.state = {
            loading: false, //数据加载等待
            model:{},
            values:{
                status:"2",
                // normalQuantity:0, // 正常产品数量
                // wornQuantity:1, //破损产品数量
                // refundAmountTotal: props.sku.pcsPrice? toFixed2(props.sku.pcsPrice*1):0,
            },
            errObj:{},//错误提示
        }
    }

    loading(flag){
        this.setState({
            loading:flag
        })
    }
    // 更新 赔付数量
    updateNum(num,callback){
        const {sku} = this.props;
        let {values} = this.state;
        values["quantity"] = num;
        values["refundAmountTotal"] = toFixed2(values.refundAmount * num) ;
        this.setState({
            values:values
        })
    }
    // 赋值
    setValue(filed,value){
        console.log("filed,value",filed,value)
        let {values} = this.state;
        values[filed] = value;
        if(filed=="refundAmountTotal"){
            values["refundAmount"] = "";
            values["priceDifferences"] = "";
            // values["refundAmount"] = toFixed2(value / values.quantity)
            // const { model } = this.props;
            // values["priceDifferences"] = toFixed2(value / model.quantity);
        }else if(filed=="refundAmount"){
            values["refundAmountTotal"] = toFixed2(values.quantity * value);
        }else if(filed=="priceDifferences"){ // 差价值
            const { model } = this.props;
            values["refundAmountTotal"] = toFixed2(model.quantity * value);
        }

        this.setState({
            values:values,
            errObj:{}
        })
    }
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6273
     ***/
    async handleOK(){
        const { model } = this.props;
        const { values } = this.state;
        let errObj = {};
        if(values.status=="3"&&isEmpty(values.cause)){ //不同意时 说明必填
            errObj["cause"] = Lang({id:"QingShuRuJieGuoShuoMing",default:"请输入结果说明"})
        }else { //同意时
            if(isEmpty(values.refundAmountTotal)||values.refundAmountTotal<=0.01){
                errObj["refundAmountTotal"] = Lang({id:"QingShuRuJinE",default:"请输入金额"})
            }
            // 单价值 改为 非必填
            // if(model.type=="damaged"&&isEmpty(values.refundAmount)){
            //     errObj["refundAmount"] = Lang({id:"QingShuRuJinE",default:"请输入金额"})
            // }
            // if(model.type=="disable"&&isEmpty(values.priceDifferences)){
            //     errObj["priceDifferences"] = Lang({id:"QingShuRuJiaCha",default:"请输入价差"})
            // }
        }
        if(isEmptyObject(errObj)){
            const sUrl = "/service/mg/sale/claimDemage/audit/submit";
            let postData ={
                claimDemageOrderId: Number(this.props.claimDemageOrderId),
                status:values.status,
            }
            postData["cause"] = values.cause
            if(values.status=="2"){
                 if(model.type=="damaged"){ // 破损
                     postData["quantity"] = values.quantity;
                     postData["refundAmount"] = values.refundAmount;
                     postData["refundAmountTotal"] = values.refundAmountTotal;
                 }else if(model.type=="disable"){ // 买贵
                     postData["quantity"] = model.quantity;
                     postData["priceDifferences"] = values.priceDifferences;
                     postData["refundAmountTotal"] = values.refundAmountTotal;
                 }

            }
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,postData,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
        }
        this.setState({
            errObj:errObj
        })
    }
    handleSaveRes(resData={},){
        // 响应结果
        this.loading(false)
        const { success,valid,model={}} = resData;
        if(success&valid){
            // 刷新页面
            message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
            if(this.props.successBack)this.props.successBack();
        }else if(resData.message){
            message.error(resData.message);
        }else message.error(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
    }

     /*
     * 初始化数据
     * */
    init(){
        const { model } = this.props;
        const mgPoInfoVO = model.mgPoInfoVO || {};
        let {values} = this.state;
        if(model.type=="damaged"){
            values = {...values,
                quantity: model.cdQuantity,
                refundAmount: mgPoInfoVO.pcsPrice,
                refundAmountTotal: toFixed2(model.cdQuantity*mgPoInfoVO.pcsPrice),
            }
        }else {
            const iPriceDifferences =  toFixed2(mgPoInfoVO.pcsPrice - model.channelPrice);
            values = {...values,
                // quantity:model.cdQuantity,
                // refundAmount: mgPoInfoVO.pcsPrice,
                priceDifferences: iPriceDifferences,
                refundAmountTotal: toFixed2(model.quantity * iPriceDifferences),
            }
        }
        this.setState({
            values:values
        })
    }
    getReg(type,value){
        switch (type) {
            case "formatter":
               return  locale=='ru'?`${value}`.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',','):`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            case "parser":
                return locale=='ru'?value.replace(/\s*/g,"").replace(',','.'):value.replace(/\$\s?|(,*)/g, '');
            default:
                return value
        }

    }
    componentWillMount() {
        this.init();
    }
    componentDidMount(){
    }

    render(){
        const {model,mgPoInfoVO} = this.props;
        const { loading,values,errObj} = this.state;
        console.log("对应值",values)
        // 单位
        const sUnit = mgPoInfoVO.skuCount>1?"PCS":__getServerDictItem("unit_type." + mgPoInfoVO.skuUnit);
        return (<Spin spinning={loading}>
            <div className={"mt_4"}>
                <Radio.Group value={values.status} size={"large"}
                             onChange={(e)=>this.setValue("status",e.target.value)}>
                    <Radio.Button value="2">
                        {Lang({id:"ShouQuanPeiShen",default:"同意赔偿"})}
                    </Radio.Button>
                    <Radio.Button value="3">
                        {Lang({id:"BuTongYi",default:"不同意"})}
                    </Radio.Button>
                </Radio.Group>
            </div>
            {/*  同意赔偿 多填的内容 */}
            {values.status=="2"&&<div className={"mt_16"}>
                <span className={"color-red2 mr_2"}>*</span>{Lang({id:"ZongPeiChangJiaZhiJinE",default:"总赔偿价值/金额"})}
                {/* 赔偿类型 */}
                {model.type=="damaged"?<div className={"mt_4 flex-item-ver-center"}>
                    <div className={"inputAdd"}>
                        <IntegerCtrlInput value={values.quantity}
                                          key={"integerCtrlInput_"+model.id}
                                          quantity={1}
                                          minNumber={1} //大于0的整数
                                          maxNumber={model.cdQuantity} // 不能超过当前商申请数量
                                          callbackChange={false}
                                          onChange={(newValue,callback)=>this.updateNum(newValue,callback)} />
                    </div>
                    <div className={"ml_6 font_16 fw_700 color-black"}>{sUnit}<span className={"ml_4 mr_4"}>×</span></div>
                    <InputNumber
                        value={values.refundAmount}
                        min={0.01}
                        max={mgPoInfoVO.pcsPrice} // 单价不能超过当前商品PCS价
                        formatter={value => this.getReg("formatter",value)}
                        parser={value => this.getReg("parser",value) }
                        placeholder={Lang({id:"QingShuRuJinE",default:"请输入金额"})}
                        precision={2}
                        onChange={(v)=>this.setValue("refundAmount",v)}
                        addonAfter={mgPoInfoVO.currencySymbol+" / "+sUnit} />
                    <span className={"ml_4 mr_4"}>=</span>
                    <InputNumber
                        value={values.refundAmountTotal}
                        min={0.01}
                        max={mgPoInfoVO.pcsPrice*values.quantity}
                        // formatter={value => locale=='ru'?`${value}`.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',','):`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        // parser={value =>  locale=='ru'?value.replace(/\s*/g,"").replace(',','.'):value.replace(/\$\s?|(,*)/g, '')}
                        formatter={value => this.getReg("formatter",value)}
                        parser={value => this.getReg("parser",value) }
                        placeholder={Lang({id:"QingShuRuJinE",default:"请输入金额"})}
                        precision={2}
                        onChange={(v)=>this.setValue("refundAmountTotal",v)}
                        addonAfter={mgPoInfoVO.currencySymbol}
                    />
                </div>:<div className={"mt_4 flex-item-ver-center"}>
                        <div className={"font_16 fw_700 color-black"}>{model.quantity}<span className={"ml_4"}>{sUnit}<span className={"ml_4 mr_4"}>×</span></span></div>
                        <InputNumber
                            value={values.priceDifferences}
                            placeholder={Lang({id:"QingShuRuJiaCha",default:"请输入价差"})}// 请输入价差
                            min={0.01}
                            max={mgPoInfoVO.pcsPrice} // 单价不能超过当前商品PCS价
                            formatter={value => this.getReg("formatter",value)}
                            parser={value => this.getReg("parser",value) }
                            precision={2}
                            onChange={(v)=>this.setValue("priceDifferences",v)}
                            addonAfter={mgPoInfoVO.currencySymbol+" / "+sUnit} />
                        <span className={"ml_4 mr_4"}>=</span>
                        <InputNumber
                            value={values.refundAmountTotal}
                            placeholder={Lang({id:"QingShuRuJinE",default:"请输入金额"})}
                            min={0.01}
                            max={toFixed2(mgPoInfoVO.pcsPrice*model.quantity)}
                            formatter={value => this.getReg("formatter",value)}
                            parser={value => this.getReg("parser",value) }
                            precision={2}
                            onChange={(v)=>this.setValue("refundAmountTotal",v)}
                            addonAfter={mgPoInfoVO.currencySymbol}
                        />
                    </div>
                }
            </div>}
            {/* 校验提示 */}
            {errObj.priceDifferences&&<div className={"color-red mt_4"}>{errObj.priceDifferences}</div>}
            {errObj.refundAmount&&<div className={"color-red mt_4"}>{errObj.refundAmount}</div>}
            {errObj.refundAmountTotal&&<div className={"color-red mt_4"}>{errObj.refundAmountTotal}</div>}
            {/*  同意赔偿 多填的内容 END */}
            <div className={"mt_16"}>
                {values.status=="3"&&<span className={"color-red2 mr_2"}>*</span>}{Lang({id:"JieGuoShuoMing",default:"结果说明"})}
            </div>
            <div className={"mt_4"}>
                <TextArea rows={5} onChange={(e)=>this.setValue("cause",e.target.value)} placeholder={Lang({id:"QingShuRu",default:"请输入"})} />
                {errObj.cause&&<div className={"color-red mt_4"}>{errObj.cause}</div>}
            </div>
            <div className={"btnWrap"}>
                <Button type="primary" size={"large"} onClick={()=>this.handleOK()}>
                    {Lang({id:"TiJiao",default:"提交"})}
                </Button>
            </div>
        </Spin>)
    }
}
